module.exports = __webpack_public_path__ + "media/images/lb/410-ad948871cdab15f224d4bcdcea00dacb.svg";